import { getHasAutomatedEmailsAuth, getHasUsersTeamsAccess, getHasUserTeamsAssignment // @ts-expect-error not migrated to TS yet
} from 'EmailData/selectors/user';
import { useSelector } from 'react-redux';
// @ts-expect-error not migrated to TS yet
import { getUser } from 'EmailData/selectors/user';
// @ts-expect-error not migrated to TS yet
import { getIsProductReadOnly } from 'EmailData/selectors/portalCritsitSelectors';
// @ts-expect-error not migrated to TS
import { setUserAttribute } from 'email-management-lib/refactor/actions/userAttributes';
import { useFetchAiSettingsAccess } from 'ai-settings-ui-library/hooks/useFetchAiSettingsAccess';
import { getTeams, getTeamsRequestSucceeded } from 'ContentData/selectors/teams';
import { archive, archiveAndCancel, cancel, confirmDelete, edit, moveToFolder, unarchive, viewEmail, viewPerformance } from 'email-management-lib/refactor/actions/manage/contentActionsShim';
import { openEmailDetailsPanel } from 'email-management-lib/refactor/actions/manage/frameworkTable';
import GenerateTranslatedVersionPanel from 'email-management-lib/refactor/components/manage/frameworkTable/components/GenerateTranslatedVersionPanel';
import ManageAccessPanel from 'email-management-lib/refactor/components/manage/frameworkTable/components/ManageAccessPanel';
import RenderActionModal from 'email-management-lib/refactor/components/manage/modals/RenderActionModal';
import EmailGroupedActionsContainer from 'email-management-lib/refactor/components/shared/EmailGroupedActionsContainer';
import { HAS_SEEN_EMAIL_INSIGHTS } from 'email-management-lib/refactor/constants/userAttributes';
import { getSubscriptions } from 'email-management-lib/refactor/selectors/manage/table';
import getActions from 'email-management-lib/refactor/utils/getActions';
import EmailModel from 'email-management-lib/Shared/models/EmailModel';
import { trackFrameworkTableInteraction } from 'EmailComponents/utils/tracking';
import { getGates } from 'EmailData/selectors/gates';
import { canAssignMultipleEmail } from 'EmailData/utils/teams';
import { getCustomTabId } from 'framework-asset-preview-lib/utils/tabs';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { List } from 'immutable';
import { INSIGHTS_PANEL_KEY } from 'messaging-publishing-lib/Insights/constant/EmailInsightsPanel';
import { memo, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EmailHoverActions({
  crmObject
}) {
  const [showManageAccessPanel, setShowManageAccessPanel] = useState(false);
  const [isTranslationPanelOpen, setIsTranslationPanelOpen] = useState(false);
  const [selectedModal, setSelectedModal] = useState(null);
  const hasAutomatedAccess = useSelector(getHasAutomatedEmailsAuth);
  const hasUsersAndTeamsAccess = useSelector(getHasUsersTeamsAccess);
  const hasManageAccessScope = canAssignMultipleEmail(hasUsersAndTeamsAccess, useSelector(getHasUserTeamsAssignment));
  const isProductReadOnly = useSelector(getIsProductReadOnly);
  const gates = useSelector(getGates);
  const isTeamsFetchSuccessful = useSelector(getTeamsRequestSucceeded);
  let teams = useSelector(getTeams);
  teams = isTeamsFetchSuccessful ? List(teams) : List();
  const user = useSelector(getUser);
  const subscriptions = useSelector(getSubscriptions);
  const userAuth = useMemo(() => ({
    user,
    gates
  }), [gates, user]);
  const dispatch = useDispatch();
  const contentActionsShim = {
    archive,
    archiveAndCancel,
    cancel,
    unarchive,
    confirmDelete,
    edit,
    viewEmail,
    viewPerformance,
    moveToFolder
  };
  const boundContentActionsShim = bindActionCreators(contentActionsShim, dispatch);
  const {
    copilotEnabled
  } = useFetchAiSettingsAccess();
  const emailObject = EmailModel.from(crmObject);
  const availableActions = useMemo(() => {
    var _subscriptions$find;
    const isInternalSubscription = (_subscriptions$find = subscriptions.find(sub => {
      return sub.value === String(emailObject.subscription);
    })) === null || _subscriptions$find === void 0 ? void 0 : _subscriptions$find.internal;
    const actions = getActions({
      email: emailObject,
      auth: userAuth,
      isProductReadOnly,
      teams,
      isInternalSubscription,
      isCopilotEnabled: copilotEnabled
    });
    actions.primary.reverse();
    return actions;
  }, [subscriptions, emailObject, userAuth, isProductReadOnly, teams, copilotEnabled]);
  const actionHandlers = useMemo(() => Object.assign({}, boundContentActionsShim, {
    assignTeams: () => {
      trackFrameworkTableInteraction({
        otherActions: 'selectUsersAndTeams'
      });
      setShowManageAccessPanel(true);
    },
    cloneOrConvert: () => {
      trackFrameworkTableInteraction({
        otherActions: 'clone-or-convertEmail'
      });
      setSelectedModal('cloneOrConvertEmail');
    },
    saveAsTemplate: () => {
      trackFrameworkTableInteraction({
        otherActions: 'save-as-template'
      });
      setSelectedModal('saveAsTemplate');
    },
    lockedSaveAsTemplate: () => {
      trackFrameworkTableInteraction({
        otherActions: 'locked-save-as-template'
      });
      setSelectedModal('lockedSaveAsTemplate');
    },
    viewDetails: () => {
      trackFrameworkTableInteraction({
        otherActions: 'view-details'
      });
      dispatch(openEmailDetailsPanel({
        crmObject
      }));
    },
    viewInsights: () => {
      trackFrameworkTableInteraction({
        otherActions: 'view-insights'
      });
      dispatch(setUserAttribute(HAS_SEEN_EMAIL_INSIGHTS, true));
      const tab = getCustomTabId(INSIGHTS_PANEL_KEY);
      dispatch(openEmailDetailsPanel({
        crmObject,
        tab
      }));
    },
    generateTranslatedVersion: () => {
      trackFrameworkTableInteraction({
        otherActions: 'generate-translated-version'
      });
      setIsTranslationPanelOpen(true);
    }
  }), [boundContentActionsShim, crmObject, dispatch]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "email-hover-actions",
    children: [/*#__PURE__*/_jsx(TFlex, {
      align: "center",
      direction: "row",
      children: /*#__PURE__*/_jsx(EmailGroupedActionsContainer, {
        actionHandlers: actionHandlers,
        availableActions: availableActions,
        content: emailObject,
        crmObject: crmObject,
        hasAutomatedAccess: hasAutomatedAccess,
        isFramework: true,
        isPreviewFooter: false,
        popoverKey: 'framework-title-row',
        responsive: true
      })
    }), selectedModal && /*#__PURE__*/_jsx(RenderActionModal, {
      onModalClose: () => setSelectedModal(null),
      openModal: modal => setSelectedModal(modal),
      selectedEmail: emailObject,
      selectedModal: selectedModal,
      crmObject: crmObject
    }), showManageAccessPanel && /*#__PURE__*/_jsx(ManageAccessPanel, {
      crmObjects: [crmObject],
      hasManageAccessScope: hasManageAccessScope,
      isAssigningAllInCurrentView: false,
      onClose: () => setShowManageAccessPanel(false),
      onSuccess: response => listingLibObserver.manageAccessSuccess(response),
      totalObjects: 1
    }), isTranslationPanelOpen && /*#__PURE__*/_jsx(GenerateTranslatedVersionPanel, {
      email: emailObject,
      onClose: () => setIsTranslationPanelOpen(false)
    })]
  });
}
export default /*#__PURE__*/memo(EmailHoverActions);